import { getCurrentObserver, setCurrentObserver } from './context';
/** Read reactive state without subscribing the active observer. */
export function untrack(read) {
    const previousObserver = getCurrentObserver();
    setCurrentObserver(null);
    try {
        return read();
    }
    finally {
        setCurrentObserver(previousObserver);
    }
}
//# sourceMappingURL=untrack.js.map